"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OCortePerfeito() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="249092" id="hero" className="bg-background text-foreground relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/precision_robotic_arm_industrial.png)] bg-blue-900 bg-gradient-to-br from-blue-600 to-blue-900" />
        <div className="absolute inset-0 bg-background/40" />
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse 55% 65% at 62% 55%, hsla(0,0%,0%,0.1) 0%, transparent 70%)"
      }} />
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to top, var(--background) 0%, transparent 60%)"
      }} />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-32 md:py-32 flex flex-col justify-center min-h-screen">
        <div className="w-full lg:w-[60%] flex flex-col gap-8">
          <div ref={headingRef} className={`transition-all duration-700 flex flex-col gap-8 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-bold text-5xl md:text-6xl lg:text-7xl leading-tight text-white" style={{
            letterSpacing: "var(--tracking-tight)",
            fontFamily: "Merriweather, serif"
          }}>
              Automation & Robotics Solutions
            </h1>

            <p className="text-lg md:text-xl max-w-xl leading-relaxed text-white" style={{
            fontFamily: "Muli, sans-serif"
          }}>
              Driving industrial excellence through our three core pillars: expert Engineering & Consulting, cutting-edge Robotics Solutions, and integrated Software & Data Services.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 z-10" style={{
      background: "linear-gradient(to top, var(--background) 0%, transparent 100%)"
    }} />
    </section>;
}